import React from 'react'
import {Link} from 'react-router-dom'
import i18n from 'i18next'
import {Module} from 'ag-common/constants/modules'
import {usePermissions} from '#hooks/usePermissions'
import AzubiGuideLogo from './svg/AzubiGuideLogo'
import Usercenter from './o/UserCenter/Usercenter'
import Search from './m/Search/index'
import HeaderChatButton from './m/Chat/HeaderChatButton'
import Notification from './m/Notification/index'
import {defaultPathForRole} from '#helpers/defaultPathForRole'
import MobileMenuToggleButton from './m/MobileMenuToggleButton'
import HeaderBanner from './a/HeaderBanner'
import useCurrentUser from '#hooks/store/useCurrentUser'
import useUserModuleSettings from '#hooks/useUserModuleSettings'

function Header() {
  const {newAusbildungsberuf, newAufbauAusbildungsberuf, role} = useCurrentUser()

  const permissions = usePermissions()
  const showBerufswechselBannerText = newAusbildungsberuf || newAufbauAusbildungsberuf
  const {showModule} = useUserModuleSettings()
  const hasChat = showModule(Module.chat)

  return (
    <header className="header">
      <div className="userinformation">
        <MobileMenuToggleButton />
        <Link to={defaultPathForRole(role)} className="logo">
          <AzubiGuideLogo />
        </Link>
      </div>
      {permissions.searchAzubi && <Search />}
      {showBerufswechselBannerText && (
        <HeaderBanner>
          <>
            <span>{`${i18n.t('berufwechsel_banner_text')} `}</span>
            <Link to="/meineausbildung">{i18n.t('berufwechsel_banner_link')}</Link>
            <span>!</span>
          </>
        </HeaderBanner>
      )}

      <div className="userinformation">
        {hasChat && <HeaderChatButton />}
        <Notification />
        <Usercenter />
      </div>
    </header>
  )
}

export default Header
